import { useMemo } from "react"
import { useSelector } from "react-redux"
import { LevelSettingType } from "@/api/FacilityLevelsService"
import { RootState } from "@/store"
import { formatLevelSettings } from "@/utils/facilities"

export function useOpenCellSchedulingEnabled(): boolean {
   const settings = useSelector(
      ({ facilitiesReducer }: RootState) =>
         facilitiesReducer.facilityDetails?.settings
   )

   return useMemo(
      () =>
         formatLevelSettings(settings ?? [])[
            LevelSettingType.OPEN_CELL_SCHEDULING_ENABLED
         ] === true,
      [settings]
   )
}
